import {
    IClientStateChangedData,
    IHapticFeedbackData,
    ILogger,
    ITopic,
    IUserInteractionChannel,
    MessageBroker,
} from '@sparkware/uc-sdk-core';
import Container, { Service } from 'typedi';
import { LoggerProvider } from '../../logger';
import { UserInteraction } from '../../user-interaction';
import { IBIEventHandler } from '../../bi/models/IBIEventHandler';
import { LoaderManager } from '../../../loaders/LoaderManager';

@Service()
export class UserInteractionChannelSubscriber {
    private readonly _logger: ILogger;
    private readonly _userInteractionChannel: IUserInteractionChannel;
    private readonly _userInteraction: UserInteraction;

    private get _biEventHandlerPromise(): Promise<IBIEventHandler> {
        return LoaderManager.Instance.BIEventHandlerLoader.Instance;
    }

    constructor() {
        this._logger = Container.get(LoggerProvider).getLogger('UIChannelSubscriber');
        this._userInteraction = Container.get(UserInteraction);
        this._userInteractionChannel = MessageBroker.getInstance().userinteraction;
        this._userInteractionChannel.topics.hapticFeedback.subscribe(
            this.onHapticFeedback.bind(this),
        );
        this._userInteractionChannel.topics.Regulation_Click.subscribe(
            this.onRegulationClick.bind(this),
        );

        this._userInteractionChannel.topics.clientStateChanged.subscribe(
            this.onClientStateChanged.bind(this),
        );
    }

    private async onHapticFeedback(data: IHapticFeedbackData) {
        this._userInteraction.onHapticFeedback(data);
    }

    private async onRegulationClick(
        { eventData, target } = { eventData: undefined, target: undefined },
    ) {
        const biEventHandler = await this._biEventHandlerPromise;
        biEventHandler?.onRegulationClick({ eventData, target });
    }

    private async onClientStateChanged(data: IClientStateChangedData) {
        const biEventHandler = await this._biEventHandlerPromise;
        biEventHandler?.onClientStateChanged(data);
    }
}
